<template>
  <path
    d="M20 6.00018H19V14.0002C19 14.5502 18.55 15.0002 18 15.0002H6V16.0002C6 17.1002 6.9 18.0002 8 18.0002H18L22 22.0002V8.00018C22 6.90018 21.1 6.00018 20 6.00018ZM17 11.0002V4.00018C17 2.90018 16.1 2.00018 15 2.00018H4C2.9 2.00018 2 2.90018 2 4.00018V17.0002L6 13.0002H15C16.1 13.0002 17 12.1002 17 11.0002Z"
  />
</template>
